import { mdiChevronDown } from '@mdi/js';
import './Components.css';
import { useEffect, useRef, useState } from 'react';
import Icon from '@mdi/react';

function Select(props) {
    const {
        options,
        value,
        variant,
        onChange
    } = props;
    const selectRef = useRef(null);
    const [selectLabel, setSelectLabel] = useState(options[0].label || options[0]);
    
    const openSelectMenu = () => {
        try {
            selectRef.current.focus()
        } catch (err) {
            const clickEvent = document.createEvent('MouseEvents');
            clickEvent.initMouseEvent('mousedown', true, true, window);
            selectRef.current.dispatchEvent(clickEvent);
        }
    }

    useEffect(() => {
        const selectedOption = options.find(option => option.value === value);
        if (selectedOption) 
            setSelectLabel(selectedOption.label);
         else 
            setSelectLabel("")
    }, [value, options]);
    
    return (<div className={"select-container  input " + variant}>
        <div className="select" onClick={openSelectMenu}>
            <span>{selectLabel}</span>
            <Icon path={mdiChevronDown} className={'icon inline'}/>
        </div>
        <select className="select" ref={selectRef} value={value} onChange={(e) => onChange(e.target.value)}>
            {options.map((option, index) => (
                <option key={index} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </div>);
}

export default Select;